import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
    title: 'Credlix Blogs',
    url: WEB_URL+'/en-us/blogs',
    description:'List of blogs in Credlix',
    keyword: 'supply chain finance, supply chain finance in USA , supply chain in finance,supply chain finance company', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
}, 
authorData: {
  authorTitle: "Author",
  authorName: "Team Credlix",
  authorBioName: 'About Team Credlix',
  authorBioTitle: "Author Bio",
  authorBio: 'Team Credlix is the editorial team behind Credlix, a global digital trade finance platform. The team writes on export finance, supply chain funding, and working capital, bringing real-world insights from MSMEs, exporters, and global trade markets to simplify complex financial decisions.',
  viewProfile: "View Profile",  
  authorH2: "Blogs by This Author",
  breadCreumbPageTitle: "Blog Author",
},  
blogviewData: {
  blogView: "Views",
  blogRead: "min read",
},
}